const baseApiPaths = {
  'initialize': 'playlists',
  'search': 'playlistsearch'
}

const actionsApiPaths = {
  'export': 'playlists/export',
  'delete': 'api/playlists',
  'edit': 'pos-sources/edit'
}

const apiPathsConfig = {
  ...baseApiPaths,
  ...actionsApiPaths
}

export default apiPathsConfig;